export const asDisplayText = (value, fallback = '-') => {
  if (value === null || value === undefined) {
    return fallback;
  }

  const text = String(value).trim();
  return text ? text : fallback;
};

const hasTimeComponent = (value) => /[T\s]\d{2}:\d{2}/.test(String(value || '').trim());

const toDate = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    const text = value.trim();
    const match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);
      const localDate = new Date(year, month - 1, day);
      if (!Number.isNaN(localDate.getTime())) {
        return localDate;
      }
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
};

export const formatDateHumanized = (value, fallback = '-') => {
  const date = toDate(value);
  if (!date) {
    return asDisplayText(value, fallback);
  }

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};

export const formatDateTimeHumanized = (value, fallback = '-') => {
  const date = toDate(value);
  if (!date) {
    return asDisplayText(value, fallback);
  }

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
};

export const formatTemporalHumanized = (value, fallback = '-') => {
  if (hasTimeComponent(value)) {
    return formatDateTimeHumanized(value, fallback);
  }

  return formatDateHumanized(value, fallback);
};
